import { ArrowRightIcon } from 'features/CaseStudy/assets/icons';
import styles from './BulletPointsList.module.css';

type BulletPointsListProps = {
  bulletPoints: string[];
};

export const BulletPointsList = ({ bulletPoints }: BulletPointsListProps) => {
  return (
    <ul className={styles.bulletPointsList}>
      {bulletPoints.map((description, index) => (
        <BulletPointsListRow key={index} text={description} />
      ))}
    </ul>
  );
};

type BulletPointsListRowProps = {
  text: string;
};

const BulletPointsListRow = ({ text }: BulletPointsListRowProps) => {
  return (
    <li className={styles.bulletPointsListElement}>
      <ArrowRightIcon className={styles.bulletPointsListMarker} />
      <span className={styles.bulletPointsListText}>{text}</span>
    </li>
  );
};
